/**
 * Data layer for `report-access-by-level-own-team-all-team-per-role`. Thin typed fetch wrappers over /api/v1/report-access-by-level-own-team-all-team-per-role.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface ReportAccessByLevelOwnTeamAllTeamPerRoleRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListReportAccessByLevelOwnTeamAllTeamPerRoleResponse {
	count: number;
	items: ReportAccessByLevelOwnTeamAllTeamPerRoleRow[];
}

export interface CreateReportAccessByLevelOwnTeamAllTeamPerRoleBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/report-access-by-level-own-team-all-team-per-role";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListReportAccessByLevelOwnTeamAllTeamPerRoleResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListReportAccessByLevelOwnTeamAllTeamPerRoleResponse>(res);
}

export async function create(body: CreateReportAccessByLevelOwnTeamAllTeamPerRoleBody): Promise<ReportAccessByLevelOwnTeamAllTeamPerRoleRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<ReportAccessByLevelOwnTeamAllTeamPerRoleRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const reportAccessByLevelOwnTeamAllTeamPerRoleQueryKeys = {
	all: ["report-access-by-level-own-team-all-team-per-role"] as const,
	list: () => [...reportAccessByLevelOwnTeamAllTeamPerRoleQueryKeys.all] as const,
	detail: (id: string) => [...reportAccessByLevelOwnTeamAllTeamPerRoleQueryKeys.all, id] as const,
};
